export default __webpack_public_path__ + "static/c679353f6b403e03b6771ebe794ed989.png";